import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasSales1P3PSplineChart = () => {
  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSaleProductCountSplineChart"
      title="Product Count"
      showLastWeekValue={true}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType="ProductsWithSalesCount"
      splineChartProps={{ chartContextId: CHART_NAMES.SALES_PRODUCT_COUNT_SPLINE }}
    />
  );
};

export default AtlasSales1P3PSplineChart;
